import { IconButton } from "@mui/material";
import React, { useState } from "react";
import ShareIcon from '@mui/icons-material/Share';

interface ShareToMarkupButtonProps {
    pdfUrl: string
}

const iconStyle = {
    "&:hover": { color: "#000 !important", cursor: "pointer" }
}

export const ShareToMarkupButton = (props: ShareToMarkupButtonProps) => {
    const [status, setStatus] = useState<"sharing" | "done" | "unsupported" | "error" | null>();

    const handleShare = async () => {
        try {
            setStatus("sharing");
            const response = await fetch(props.pdfUrl, { mode: "cors" });
            const blob = await response.blob();
            const file = new File([blob], "annotate.pdf", { type: "application/pdf" });

            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                await navigator.share({
                    title: "Annotate this question",
                    text: "Open in Markup to annotate.",
                    files: [file],
                });
                setStatus("done");
            }
            else {
                setStatus("unsupported");
                alert("Sharing not supported on this browser 😢");
            }
        }
        catch (error) {
            console.error("Share failed:", error);
            setStatus("error");
            alert("Something went wrong while sharing.");
        }
        finally {
            setTimeout(() => setStatus(null), 2000); // reset status
        }
    };

    return (
        <IconButton
            title="share"
            aria-label="Share"
            sx={{ ...iconStyle }}
            color="secondary"
            onClick={handleShare}
            disabled={status != null}
        >
            <ShareIcon />
        </IconButton>
    );
}
